// import NotFoundPage from "pages/not-found-page";
import { Navigate, Outlet } from "react-router-dom";


function PrivateRoute() {
    return localStorage.getItem("isLogged") === "true" ? <Outlet /> : <Navigate to="/login" replace />;

}

export default PrivateRoute